export default (apiFetch) => async (payload) => {
  const response = await apiFetch({
    endpoint: "subscribe",
    method: "POST",
    body: payload,
    headers: {},
  });

  return await response.json();
};
